@if (data$ | async; as data) {
  <cx-generic-link
    [url]="data.url"
    [target]="getTarget(data)"
    >
    @if (data.styleAttributes) {
      <cx-icon
        [type]="'HELP'"
        class="mr-2 small"
        ></cx-icon
        >
        }{{ data.linkName }}
      </cx-generic-link>
    }
